import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { formatTime } from '../../utils';

const propTypes = {
  currentTime: PropTypes.number,
  duration: PropTypes.number,
  percentage: PropTypes.string,
  className: PropTypes.string,
};

// Shows play progress
export default function PlayProgressBar({ hasDVR, latency, currentTime, duration, percentage, className }) {

  return (
    <div
      data-current-time={formatTime(currentTime, duration)}
      className={classNames('video-react-play-progress video-react-slider-bar', className)}
      style={{
        width: (latency <= 20 && hasDVR) ? '100%' : percentage,
      }}
    >
      <span className="video-react-control-text"><span>Progress</span>: {percentage}</span>
    </div>
  );
}

PlayProgressBar.propTypes = propTypes;
PlayProgressBar.displayName = 'PlayProgressBar';
